const exportData = {
  END_OF_WORK: 'endOfWork',
  EVERY_WEEK: 'everyWeek',
  EVERY_TWO_WEEKS: 'everyTwoWeeks',
  ONCE_MONTH: 'onceMonth',
  END_OF_WORK_TEXTS: 'В конце смены',
  EVERY_WEEK_TEXT: 'Каждую неделю',
  EVERY_TWO_WEEKS_TEXT: 'Каждые две недели',
  ONCE_MONTH_TEXT: 'Раз в месяц',
  CHAR_OF_ACTUAL: '🔥',
};

exportData.DATE_OF_PAYMENT_TEXTS_MAPPING = {
  [exportData.END_OF_WORK]: exportData.END_OF_WORK_TEXTS,
  [exportData.EVERY_WEEK]: exportData.EVERY_WEEK_TEXT,
  [exportData.EVERY_TWO_WEEKS]: exportData.EVERY_TWO_WEEKS_TEXT,
  [exportData.ONCE_MONTH]: exportData.ONCE_MONTH_TEXT,
};

module.exports = exportData;
